// extracted by mini-css-extract-plugin
module.exports = {"p":"P-module__p___fx52B"};